import { render, staticRenderFns } from "./ProcessSelector.vue?vue&type=template&id=57ff37d6&scoped=true"
import script from "./ProcessSelector.vue?vue&type=script&lang=js"
export * from "./ProcessSelector.vue?vue&type=script&lang=js"
import style0 from "./ProcessSelector.vue?vue&type=style&index=0&id=57ff37d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff37d6",
  null
  
)

export default component.exports